import { render, staticRenderFns } from "./CustomerAddressUpdate.vue?vue&type=template&id=7071196f&"
import script from "./CustomerAddressUpdate.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddressUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports